import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'dibs-react-tooltip';
import 'dibs-react-tooltip/dist/main.css';

class DealerDistinction extends Component {
    constructor(props) {
        super(props);

        this.state = { isHovered: false };
    }

    render() {
        const { title, description, icon: Icon } = this.props;

        return (
            <div>
                <div
                    className="pdp-dealer-distinction"
                    onMouseEnter={() => this.setState({ isHovered: true })}
                    onMouseLeave={() => this.setState({ isHovered: false })}
                >
                    <Icon className="pdp-dealer-distinction-icon" />
                    <span className="pdp-dealer-distinction-title">{title}</span>

                    {description && (
                        <Tooltip
                            isVisible={this.state.isHovered}
                            tooltipDirection="bottom"
                            lockDirection
                        >
                            {description}
                        </Tooltip>
                    )}
                </div>
            </div>
        );
    }
}

DealerDistinction.propTypes = {
    title: PropTypes.node.isRequired,
    description: PropTypes.node,
    icon: PropTypes.func.isRequired,
};

export default DealerDistinction;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ContactDealer/DealerDistinctions/DealerDistinction.jsx